export const initialise = () => {
    const page = document.querySelector<HTMLBodyElement>('.layout-post')
    const widgets = document.querySelectorAll<HTMLElement>('.post-categories-widget, .tags-widget')
    if (!page || !widgets) return
    widgets.forEach(widget => {
        filters(widget)
    })
}

const filters = (widget: HTMLElement) => {
    const filter = widget.querySelector<HTMLDivElement>('.attrax-post-filters')
    const list = widget.querySelector<HTMLDivElement>('.attrax-post-filters__list')
    const header = widget.querySelector<HTMLDivElement>('.attrax-post-filters__heading-container')
    if (!filter || !list || !header) return

    const button: HTMLButtonElement = document.createElement('button')
    button.className = 'attrax-post-filters__heading-container'
    button.innerHTML = header.innerHTML
    button.setAttribute('aria-expanded', 'false')
    filter.prepend(button)
    header.remove()

    button.setAttribute('aria-expanded', 'false')
    list.setAttribute('aria-hidden', 'true')

    button.addEventListener('click', function(event: Event) {
        const isExpanded: boolean = filter.classList.toggle('filter-open')
        button.setAttribute('aria-expanded', isExpanded.toString())
        list.setAttribute('aria-hidden', (!isExpanded).toString())
    })
}
